// import React from 'react';
// import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
// import { Home, List, AccountBalance, AccountCircle } from '@mui/icons-material';
// import { useNavigate, useLocation } from 'react-router-dom';

// function NavBar() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [value, setValue] = React.useState(location.pathname);

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//     navigate(newValue);
//   };

//   return (
//     <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
//       <BottomNavigation value={value} onChange={handleChange}>
//         <BottomNavigationAction label="Watchlist" value="/" icon={<Home />} />
//         <BottomNavigationAction label="Trades" value="/trades" icon={<List />} />
//         <BottomNavigationAction label="Portfolio" value="/portfolio" icon={<AccountBalance />} />
//         <BottomNavigationAction label="Profile" value="/profile" icon={<AccountCircle />} />
//       </BottomNavigation>
//     </Paper>
//   );
// }

// export default NavBar;


import React, { useEffect, useState, useContext, useRef } from 'react';
import { BottomNavigation, BottomNavigationAction, Paper, Box, Typography, Divider } from '@mui/material';
import { 
  TrendingUp, 
  TrendingDown, 
  Assessment, 
  AccountBalance, 
  History,
  ExpandMore,
  ExpandLess
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { WebSocketContext } from '../WebSocketContext';
import './NavBar.css'; // Import custom CSS file
import BottomTime from './BottomTime';
import { apiAppFetch } from '../utils/apiFetch';

function NavBar() {
  const { isDarkMode } = useTheme();
  const { userDetails } = useContext(WebSocketContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = React.useState(location.pathname);
  const [marqueeText, setMarqueeText] = useState(null);
  const [showMarginBox, setShowMarginBox] = useState(false);
  const marginBoxRef = useRef(null);

  const getTodayScrollText = async () => {
      try 
      {  
        const response = await apiAppFetch('getTodayScrollText', {
          method: 'POST',
          body: JSON.stringify({}),
        });

        if (!response.ok) {
          return;
        }

        const data = await response.json();
        setMarqueeText(data.text); 

      } catch (error) {
        // fetch failed silently
      }
  };

  useEffect(() => {
    getTodayScrollText();
  }, []);

  useEffect(() => {
    setValue(location.pathname);
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  const toggleMarginBox = () => {
    setShowMarginBox(!showMarginBox);
  };

  useEffect(() => {
    if (!showMarginBox) return;

    const handleOutsideClick = (event) => {
      if (marginBoxRef.current && !marginBoxRef.current.contains(event.target)) {
        setShowMarginBox(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('touchstart', handleOutsideClick);
    };
  }, [showMarginBox]);

  return (
    <div className={`bottom-navigation ${isDarkMode ? 'dark-theme' : 'light-theme'}`} data-theme={isDarkMode ? 'dark' : 'light'}>
      {/* Margin Box */}
      {showMarginBox && (
        <div className="margin-box" ref={marginBoxRef}>
          <div className="margin-box-header">
            <Typography variant="h6" className="margin-box-title">Account Summary</Typography>
            <button className="margin-box-close" onClick={toggleMarginBox}>
              <ExpandMore />
            </button>
          </div>
          <div className="margin-box-content">
            <div className="margin-row">
              <div className="">
                <span className="margin-label">M2M Limit:</span>
                <span className={`margin-value ${userDetails?.m2m_limit < 0 ? 'negative' : 'positive'}`}>
                  ₹{Number(userDetails?.m2m_limit || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                </span>
              </div>
              <div className="">
                <span className="margin-label">Booked P&L:</span>
                {/* <span className="margin-value ${(userDetails?.m2m_balance - userDetails?.m2m_limit) < 0 ? 'negative' : 'positive'}"> */}
                <span className={`margin-value ${(userDetails?.m2m_balance - userDetails?.m2m_limit) < 0 ? 'negative' : 'positive'}`}>
                  ₹{Number(userDetails?.m2m_balance - userDetails?.m2m_limit || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                </span>
              </div>
            </div>
            {/* <div className="margin-row">
              <span className="margin-label">Floating P&L:</span>
              <span className={`margin-value ${userDetails?.floatingPL < 0 ? 'negative' : 'positive'}`}>
                ₹{Number(userDetails?.floatingPL || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
              </span>
            </div> */}
            <div className="margin-row">
              <div className="">
                <span className="margin-label">Used Margin:</span>
                <span className="margin-value positive">
                  ₹{Number((userDetails?.m2m_balance - userDetails?.availableMargin) || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                </span>
              </div>
              {/* <Divider className="margin-divider" /> */}
              <div className="">
                <span className="margin-label">Free Margin:</span>
                <span className="margin-value positive">
                  ₹{Number(userDetails?.availableMargin || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                </span>
              </div>
            </div>
            {/* <div className="margin-row">
              <span className="margin-label">Holding Margin:</span>
              <span className="margin-value positive">
                ₹{Number(userDetails?.holdingMargin || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
              </span>
            </div> */}
            {/* <div className="margin-row">
              <span className="margin-label">Credit:</span>
              <span className="margin-value positive">
                ₹{Number(userDetails?.credit || 0).toLocaleString('en-IN', { minimumFractionDigits: 0 })}
              </span>
            </div> */}
            {/* <div className="margin-row">
              <span className="margin-label">Account:</span>
              <span className="margin-value positive">
                {userDetails?.accountNumber || 'N/A'}
              </span>
            </div> */}
            {/* <div className="margin-row">
              <span className="margin-label">Margin Level:</span>
              <span className="margin-value positive">
                {Number(userDetails?.marginLevel || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}%
              </span>
            </div> */}
          </div>
        </div>
      )}

      <div className="nav-container">
        <button 
          className={`nav-item ${value === '/' ? 'active' : ''}`}
          onClick={() => handleChange(null, '/')}
        >
          <div className="nav-icon">
            <TrendingUp />
            <TrendingDown />
          </div>
          <span>Quotes</span>
        </button>
        <button 
          className={`nav-item ${value === '/trades' ? 'active' : ''}`}
          onClick={() => handleChange(null, '/trades')}
        >
          <div className="nav-icon">
            <Assessment />
          </div>
          <span>Trades</span>
        </button>
        <button className="nav-item trade-button" onClick={toggleMarginBox}>
          <div className="nav-icon">
            {showMarginBox ? <ExpandMore /> : <ExpandLess />}
          </div>
        </button>
        <button 
          className={`nav-item ${value === '/positions' ? 'active' : ''}`}
          onClick={() => handleChange(null, '/positions')}
        >
          <div className="nav-icon">
            <AccountBalance />
          </div>
          <span>Portfolio</span>
        </button>
        <button 
          className={`nav-item ${value === '/performance' ? 'active' : ''}`}
          onClick={() => handleChange(null, '/performance')}
        >
          <div className="nav-icon">
            <History />
          </div>
          <span>Performance</span>
        </button>
      </div>
      <marquee className="nav-marquee">
        {marqueeText}
      </marquee>
      <BottomTime />
    </div>
  );
}

export default NavBar;

